import { render, staticRenderFns } from "./CollapsedForm.vue?vue&type=template&id=a1d8270e&scoped=true&lang=pug"
import script from "./CollapsedForm.vue?vue&type=script&lang=js"
export * from "./CollapsedForm.vue?vue&type=script&lang=js"
import style0 from "./CollapsedForm.vue?vue&type=style&index=0&id=a1d8270e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d8270e",
  null
  
)

export default component.exports